import React, { memo } from 'react';
import { AccordionHeaderProps } from './types';
import Tooltip from '../tooltip';
import './styles.scss';
import { generateID } from '../../base/helper';

const Header: React.FC<AccordionHeaderProps> = ({
  id = generateID('clientos-ui-toolkit-accordion'),
  start,
  tooltip,
  children,
  paddingBottom = true,
  paddingEnd = true,
  paddingStart = true,
  paddingTop = true,
  size = 'xl',
  variant = 'subtle'
}) => {
  return (
    <div
      id={id}
      className={`clientos-ui-toolkit-accordion__item${paddingStart ? ' padding-start' : ''}${paddingEnd ? ' padding-end' : ''} ${paddingTop ? ' padding-top' : ''}${paddingBottom ? ' padding-bottom' : ''}`}
    >
      {start && (
        <div
          className="clientos-ui-toolkit-accordion__item__icon"
          id={`${id}-start`}
        >
          {start}
        </div>
      )}
      <span
        className={`clientos-ui-toolkit-accordion__item__headline clientos-ui-toolkit-accordion__item__headline--${size}`}
        id={`${id}-children`}
      >
        {children}
      </span>
      {tooltip && (
        <Tooltip
          content={tooltip.content}
          id={`${id}-tooltip`}
        >
          {tooltip.children}
        </Tooltip>
      )}
    </div>
  );
};

export default memo(Header);
